<template>
    <div class="container-fluid" style="padding-left: 60px; padding-right: 60px;">
        <div class="container-fluid" v-if="activePageCRU==0">
            <div class="row mb-1">
              <div class="col-sm pb-1 text-start">
                <span class="badge rounded-pill pull-left mt-1 py-2 px-4" style="font-size:18px; background:purple">
                    <b>Receipts : ใบเสร็จรับเงิน</b>
                </span>
              </div>
            </div>
            <div class="row">
                <div class="col-sm">
                    <div class="row">
                      <div class="col-sm-4">
                          <!-- สาขาแล็บ -->
                          <div class="input-group input-group-sm">
                              <div class="input-group-prepend">
                              <span class="input-group-text" style="width:120px;">สาขา* :</span>
                              </div>
                              <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID">
                                  <option disabled value="">Please select one</option>
                                  <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                              </select>
                          </div>
                      </div>
                      <div class="col-sm-7">
                          <!-- วันที่ใบสั่งตรวจ -->
                          <div class="input-group input-group-sm mb-1">
                          <div class="input-group-prepend">
                              <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                          </div>
                          <v-date-picker mode="date" v-model="dateFm" :masks="masks" title="วันที่เอกสารเริ่มต้น">
                              <template v-slot="{ inputValue, inputEvents }">
                                  <input name="dateFm" ref="dateFm" style="width:120px;"
                                  class="bg-white border px-2 py-1 rounded"
                                  :value="inputValue"
                                  v-on="inputEvents"
                                  />
                              </template>
                          </v-date-picker>
                          <v-date-picker mode="date" v-model="dateTo" :masks="masks" title="วันที่เอกสารสิ้นสุด">
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input name="dateTo" ref="dateTo" style="width:120px;"
                                  class="bg-white border px-2 py-1 rounded"
                                  :value="inputValue"
                                  v-on="inputEvents"
                                  />
                                </template>
                            </v-date-picker>
                            <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                          </div>
                      </div>
                      <div class="col-sm-1">
                        <button type="button" class="btn btn-primary btn-sm text-white float-end mx-2"
                          style="width:120px;" @click="newRecord()">New</button>
                      </div>
                    </div>
                </div>
            </div>
            <!-- ตารางใบสั่งตรวจ สถานะใหม่และป้อนผล ตามเงื่อนไขสาขาและวันที่เอกสาร -->
            <RcptCreate1View :datalists="datalists" :key="countRefresh"
                @onEditRecordEvent="editRecord"
                @onBackPageAfterSaveEvent="backPageAfterSave"></RcptCreate1View>
        </div>
        <div class="container-fluid" v-if="activePageCRU==1">
            <RcptCreate2New
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataPaymentlists="dataPaymentlists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></RcptCreate2New>
        </div>
        <!-- หน้าจอแก้ไขใบสั่งตรวจ (ยังไม่ได้ป้อนผล) -->
        <div class="container-fluid" v-if="activePageCRU==2">
            <RcptCreate3Edit
              :rowEdit="curRecord"
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataPaymentlists="dataPaymentlists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></RcptCreate3Edit>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import LabCreate1View from './LabCreate1View.vue'
import RcptCreate1View from './RcptCreate1View.vue'
import RcptCreate2New from './RcptCreate2New.vue'
import RcptCreate3Edit from './RcptCreate3Edit.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabCreate',
  data () {
    return {
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      // status0New: true,
      status1Lab: true,
      status2Res: false,
      // status3App: true,

      countRefresh: 0,
      activePageCRU: 0, // 0-View or Read/ 1-Create/ 2-Update
      // False : แสดงหน้าจอ View,  True : แสดงหน้าจอป้อนผลแล็บ
      datalists: null,
      curRecord: null,
      PatName: '',
      action: 'new',
      // ชุดตรวจสำหรับแสดงใน Modal เพื่อเลือกใส่ใบสั่งตรวจ
      dataTestSuitlists: null,
      // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
      dataCliniclists: null,
      // รายชื่อ พนง ในระบบ สำหรับเลือกใน Header Table
      dataOfficerlists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      // รายชื่อ specimen ทั้งหมด
      dataSpecimenlists: null,
      // รายชื่อ ห้องตรวจ ทั้งหมด สำหรับใช้กรองชุดตรวจ ขณะเลือก
      dataRoomtypelists: null
    }
  },
  created () {
    // Initial Value
    // this.getOfficerData()
    // this.getBranchData()
  },
  mounted () {
    this.getTestSuitData()
    this.getClinicData()
    this.getOfficerData()
    this.getBranchData()
    this.getSpecimenData()
    this.getRoomtypeData()
    this.getPaymentData()

    this.branchID = this.globalBranchID
    // ดึงข้อมูลรายการใบสั่งตรวจ
    this.getData()
  },
  components: {
    RcptCreate1View,
    RcptCreate2New,
    RcptCreate3Edit
  },
  methods: {
    getPaymentData () {
      MyApiClient.get('getdata/payment_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataPaymentlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getRoomtypeData () {
      MyApiClient.get('getdata/roomtype_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataRoomtypelists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getSpecimenData () {
      MyApiClient.get('getdata/specimen_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataSpecimenlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
    getClinicData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/clinicreq_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataCliniclists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // ชุดตรวจทั้งหมด สำหรับเลือกในใบสั่งตรวจ
    getTestSuitData () {
      // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/testsuits_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataTestSuitlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // Callback หลังจาก 1-บันทึกเอกสารใหม่ และ 2-ยกเลิกเอกสาร
    backPageAfterSave () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 0
      this.$nextTick(() => {
        $('#myLabReqTable').DataTable()
      })
      // ดึงข้อมูลรีเฟรชตารางใบสั่งตรวจ
      this.getData()
    },
    backPage () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 0
      this.$nextTick(() => {
        $('#myLabReqTable').DataTable()
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 1 // 0-View 1-New 2-Edit
    },
    editRecord (row) {
      this.curRecord = row
      this.action = 'edit'
      this.activePageCRU = 2 // 0-View 1-New 2-Edit
    },
    getData () {
      // -------- Date From -----------
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateFm = YYYY + '-' + MM + '-' + DD
      // -------- Date To -----------
      d = this.dateTo
      YYYY = d.getFullYear().toString()
      MM = ''
      DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateTo = YYYY + '-' + MM + '-' + DD

      var BranchID = this.branchID
      MyApiClient.get('getdata/rcpt_where.php?C1=' + this.globalCorpID +
      '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          //   setTimeout(function () { $('#myLabReqTable1').DataTable() }, 0)
          setTimeout(function () { $('#myLabReqTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
